import { render, staticRenderFns } from "./category3.vue?vue&type=template&id=344fc884"
import script from "./category3.vue?vue&type=script&lang=js"
export * from "./category3.vue?vue&type=script&lang=js"
import style0 from "./category3.vue?vue&type=style&index=0&id=344fc884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports